// NavigationService.ts
import { NavigateFunction } from "react-router-dom";

let globalNavigate: NavigateFunction | null = null;

export const setGlobalNavigate = (navigate: NavigateFunction) => {
  globalNavigate = navigate;
};

export const navigateTo = (path: string, options?: { replace?: boolean }) => {
  if (globalNavigate) {
    globalNavigate(path, options);
  } else {
    window.location.href = path;
  }
};
